import REPORT from './Report';

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/IVRReport/components/index.js